<template>
    <div>
      <b-container fluid class="change-atm-pin p-0 m-0">
          <b-row>
            <b-col xl="12" class="mx-auto">
                <div class="block-item px-5 py-5">
                    <h3>{{ $t('Payment Password') }}</h3>
                    <small class="text-grey2 mb-4 d-block ml-1">{{ $t("Please input your new payment password.") }}</small>
                    <div class="d-flex mb-4">
                        <input type="text" class="form-control mx-2 fz-24 fw-500 text-center" v-for="index in 6" maxlength="1" @input="onInput" v-on:keydown="onKeyDown" v-model="pin[index-1]">
                    </div>
                    <div class="d-flex flex-column mx-1">
                        <button class="btn btn-primary" @click="onSubmit">{{ $t('Submit') }}</button>
                    </div>
                </div>
            </b-col>
          </b-row>
      </b-container>
    </div>
  </template>
  <script>
  
    export default {
        name: 'payment-password',
        data() {
            return {
                publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
                card_number : '',
                pin:['','','','','',''],
                show_password:false,
                password:'',
                error:{
                    password:''
                }
            }
        },
        methods:{
            toggleShow(name) {
                this["show_"+name] = !this["show_"+name];
            },
            onChange(name){
                this.error[name]="";
            },
            onKeyDown(e){
                if(e.keyCode==8 && !e.target.value && e.target.previousSibling){
                    e.target.previousSibling.focus();
                }
            },
            onInput(e){
                console.log(e);
                if(e.target && e.data && e.target.nextSibling){
                    e.target.nextSibling.focus();
                }
            },
            getMessage: function (key) {
            return this.$t(key)
            },
            onSubmit(){
                this.$emit('on-submit',this.pin);
            }
        },
        mounted(){
            
        }
    };
  </script>

<style>
#modal-payment-password .modal-body{
    padding: 0 !important;
}
#modal-payment-password .modal-header{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
}
.change-atm-pin .form-control:focus{
    border-color: #F8C617 !important;
}
</style>